import logo from '../../images/LogoSmallColored-nav.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faBath, faBed, faCircleMinus, faCirclePlus, faCouch, faKitchenSet, faLocationDot, faMinus, faMountain, faPlus, faShower, faStar, faToiletPaper, faUmbrellaBeach, faWaterLadder } from '@fortawesome/free-solid-svg-icons';
import { DateRangePicker, DayPickerRangeController } from 'react-dates';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'moment/locale/en-au'
import 'moment/locale/ar-ly'
import LocationMap from '../LocationMap/LocationMap';
import $ from 'jquery'
import { useApi } from '../Store/ApiContext';
import ContentLoader from 'react-content-loader';
import PictureSlider from '../PictureSlider/PictureSlider';
import ContactsPopup from '../ContactsPopup/ContactsPopup';
// import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MobileBooking from '../MobileBooking/MobileBooking';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../Footer/Footer';
import axios from 'axios';
import { toast } from 'react-toastify';
import ConfirmPayment from '../ConfirmPayment/ConfirmPayment';
import SigninPopup from '../SigninPopup/SigninPopup';
import PaymentMethods from '../PaymentMethods/PaymentMethods';
import { t } from 'i18next';

moment.locale("ar-ly"); // move locale to module scope

// Constants and configurations - Fix icon references
const SERVICES_CONFIG = {
    'Beach view': { icon: faUmbrellaBeach, label: 'Beach view' },
    'Sea View': { icon: faUmbrellaBeach, label: 'Sea View' },
    'Overlooking pool': { icon: faUmbrellaBeach, label: 'Overlooking pool' },
    'stove': { icon: faKitchenSet, label: 'stove' },
    'office': { icon: faCouch, label: 'office' },
    'heater': { icon: faShower, label: 'heater' },
    'Mountain view': { icon: faMountain, label: 'Mountain view' }
};

const INITIAL_BOOKING_DATA = {
    reqFrom: null,
    reqTo: null,
    reqGuests: 1,
    reqNights: 0,
    reqTotalCost: 0,
    unit: null,
    idsImg: [],
    orgPaymentMethod: null,
    paymentImage: []
};

const INITIAL_DATE_RANGE = {
    startDate: null,
    endDate: null
};

// Custom hooks
const useBookingCalculation = (data, baseUrl, bookingData, getSlug) => {
    const [availableTime, setAvailableTime] = useState(null);
    const [transaction, setTransaction] = useState([]);

    const calcPriceNightsPerAvailableTime = useCallback((availableTimes, date) => {
        let diffDaysCollect = 0;
        const transaction = [];
        const inputStartDate = moment(date.startDate).startOf('day');
        const inputEndDate = moment(date.endDate).startOf('day');

        // // Fix: Add early return if no available times
        // if (!availableTimes || availableTimes.length === 0) {
        //     setAvailableTime(true);
        //     return { transaction: [], allNights: 0 };
        // }

        let hasAvailableTime = false;

        availableTimes?.forEach((availableTime, i) => {
            const availableTimeStartDate = moment(availableTime.startDate).startOf('day');
            const availableTimeEndDate = moment(availableTime.endDate).startOf('day');

            if (availableTime?.available) {
                hasAvailableTime = true;
                let diff;

                if (i === 0 && inputStartDate.isSameOrAfter(availableTimeStartDate)) {
                    diff = availableTimeEndDate.isAfter(inputEndDate)
                        ? inputEndDate.diff(inputStartDate, "days")
                        : availableTimeEndDate.diff(inputStartDate, "days");
                } else if (i === (availableTimes.length - 1) && inputEndDate.isSameOrBefore(availableTimeEndDate)) {
                    diff = inputEndDate.diff(availableTimeStartDate, "days");
                } else {
                    diff = availableTimeEndDate.diff(availableTimeStartDate, "days");
                }

                diffDaysCollect += diff;
                transaction.push({ nights: diff, price: availableTime.price });
            } else {
                setAvailableTime(false);
            }
        });

        // // Fix: Set available time status after processing all times
        // setAvailableTime(hasAvailableTime);
        const allNights = inputEndDate.diff(inputStartDate, "days");
        console.log({ inputStartDate, inputEndDate, transaction, allNights });

        // if (hasAvailableTime) {
        //     setTransaction(transaction);
        //     return { transaction, allNights };
        // } else {
        const diffDays = allNights - diffDaysCollect;
        if (diffDays > 0) {
            transaction.push({ nights: diffDays, price: data.unit?.cost || 0 });
        }
        setTransaction(transaction);
        console.log(transaction);

        return { transaction, allNights };
        // }
    }, [data.unit?.cost]);

    const getAvailableTimeUnit = useCallback(async (startDate, endDate) => {
        try {
            const slug = getSlug();
            const { data: response } = await axios.get(
                `${baseUrl}listing/booking/availableTimeUnit/${slug}/${bookingData.unit}?startDate=${startDate}&endDate=${endDate}`,
                { headers: { 'Content-Type': 'application/json' } }
            );

            if (response?.message === "success") {
                return calcPriceNightsPerAvailableTime(response.results, { startDate, endDate });
            }
            return null;
        } catch (error) {
            console.error('Error fetching available time:', error);
            return null;
        }
    }, [baseUrl, bookingData.unit, getSlug, calcPriceNightsPerAvailableTime]);

    return { availableTime, transaction, getAvailableTimeUnit };
};

// Service renderer component - Fix icon reference
const ServiceItem = ({ service }) => {
    const config = SERVICES_CONFIG[service];
    if (!config) return null;

    return (
        <li className='my-2'>
            <FontAwesomeIcon icon={config.icon} />
            <span className='me-1'>{t(config.label)}</span>
        </li>
    );
};

// Main component
export default function PreviewUnit({ baseUrl }) {
    // State management
    const navigate = useNavigate();
    const params = useParams();
    const { getData, getSlug, decodeToken, responseApi } = useApi();

    const [mobileView, setMobileView] = useState(false);
    const [oldClientName, setOldClientName] = useState("");
    const [focusedInput, setFocusedInput] = useState("startDate");
    const [focusedInput2, setFocusedInput2] = useState(null);
    const [data, setData] = useState({});
    const [showMoreServices, setShowMoreServices] = useState(false);
    const [dateRange, setDateRange] = useState(INITIAL_DATE_RANGE);
    const [bookingPolicies, setBookingPolicies] = useState({});
    const [bookingData, setBookingData] = useState({
        ...INITIAL_BOOKING_DATA,
        unit: params.id
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [availableTimesMap, setAvailableTimesMap] = useState(new Map());

    // Custom hooks
    const { availableTime, transaction, getAvailableTimeUnit } = useBookingCalculation(
        data, baseUrl, bookingData, getSlug
    );

    // Load booking policies from backend
    const loadBookingPolicies = async () => {
        try {
            // booking policies
            const bookingPoliciesCached = sessionStorage.getItem(`bookingPolicies`);
            if (bookingPoliciesCached) {
                setBookingPolicies(JSON.parse(bookingPoliciesCached));
            } else {
                const data = await getData(`bookingPolicies/${getSlug()}`);
                // response shape may vary; handle results.bookingPolicies or results
                if (data) {
                    setBookingPolicies(data.bookingPolicies);
                    sessionStorage.setItem("bookingPolicies", JSON.stringify(data.bookingPolicies));
                }
            }
        } catch (error) {
            console.error('Error loading booking policies:', error);
            // enqueueSnackbar(t('loadingFailed') || 'Failed to load policies', { variant: 'error' });
        }
    };

    // Memoized values - Move all useMemo hooks here
    const servicesHtml = useMemo(() => {
        if (!data.unit?.services) return [];

        return data.unit.services
            .filter(service => SERVICES_CONFIG[service])
            .map((service, index) => (
                <ServiceItem key={index} service={service} />
            ));
    }, [data.unit?.services]);

    const displayedServices = useMemo(() => {
        const half = Math.ceil(servicesHtml.length / 2);
        return {
            firstColumn: showMoreServices ? servicesHtml.slice(0, half) : servicesHtml.slice(0, 4),
            secondColumn: showMoreServices ? servicesHtml.slice(half) : servicesHtml.slice(4, 8)
        };
    }, [servicesHtml, showMoreServices]);

    const isDateRangeValid = useMemo(() => {
        return dateRange?.startDate &&
            dateRange?.endDate &&
            moment(dateRange.endDate).isValid() &&
            moment(dateRange.startDate).isValid();
    }, [dateRange]);

    const renderTransactionDetails = useMemo(() => (
        <div className='d-flex justify-content-between mx-3 align-items-center my-3 calc-booking'>
            <div>
                {transaction?.map((trans, index) => (
                    <p key={`nights-${index}`}>
                        <span>{trans.nights}</span> ليلة *
                        <span> {data.unit?.costInterval === "night" ? trans.price : (trans.price / 30.5).toFixed(2)} </span>ج.م
                    </p>
                ))}
            </div>
            <div>
                {transaction?.map((trans, index) => (
                    <p key={`cost-${index}`}>
                        <span>
                            {data.unit?.costInterval === "night"
                                ? trans.nights * trans.price
                                : (trans.nights * trans.price / 30.5).toFixed(2)
                            }
                        </span> ج.م
                    </p>
                ))}
            </div>
        </div>
    ), [transaction]);

    // Event handlers - Move all useCallback hooks here
    const handleChangeDate = useCallback((e) => {
        if (e.startDate && e.endDate) {
            const { checkInHours, checkInMinutes, checkOutHours, checkOutMinutes } = getStandardTime();

            setDateRange({
                startDate: moment(e.startDate).set({ hour: checkInHours, minute: checkInMinutes, second: 0, millisecond: 0 }),
                endDate: moment(e.endDate).set({ hour: checkOutHours, minute: checkOutMinutes, second: 0, millisecond: 0 })
            });
        } else {
            setDateRange({ ...e });
        }
    }, [bookingPolicies]);

    const handleChangePlusGuests = useCallback(() => {
        setBookingData(prev => ({ ...prev, reqGuests: prev.reqGuests + 1 }));
    }, []);

    const handleChangeMinusGuests = useCallback(() => {
        setBookingData(prev =>
            prev.reqGuests > 1 ? { ...prev, reqGuests: prev.reqGuests - 1 } : prev
        );
    }, []);

    const handleFocusChange = useCallback((focusedInput) => {
        setFocusedInput(focusedInput || "startDate");
    }, []);

    const isOutsideRange = useCallback((day) => {
        return day.isBefore(moment().subtract(1, "day"));
    }, []);

    // Memoized available times map for displaying prices
    const availableTimesMapMemo = useMemo(() => {
        const availableTimes = data.availableTimes || [];
        const timesMap = new Map();

        availableTimes.forEach(timeSlot => {
            if (!timeSlot.startDate || !timeSlot.endDate || !timeSlot.price) return;

            const startDate = moment(timeSlot.startDate).startOf('day');
            const endDate = moment(timeSlot.endDate).startOf('day');
            const price = timeSlot.price;

            // Map each day in the range to its price
            let current = startDate.clone();
            while (current.isBefore(endDate)) {
                const dayKey = current.format('YYYY-MM-DD');
                timesMap.set(dayKey, price);
                current.add(1, 'day');
            }
        });

        return timesMap;
    }, [data.availableTimes]);
    // Add this new memoized blocked dates calculation
    const blockedDates = useMemo(() => {
        const requestsAccepted = data.requests || [];
        const blockedDatesSet = new Set();

        // Pre-calculate all blocked dates for better performance
        for (const request of requestsAccepted) {
            const { reqFrom, reqTo } = request;
            if (reqFrom && reqTo) {
                const startDate = moment(reqFrom);
                const endDate = moment(reqTo);

                // Add all dates between reqFrom and reqTo to blocked set
                // Skip the last day (checkout day) to make it available for new bookings
                const current = startDate.clone();
                while (current.isBefore(endDate, 'day')) {
                    blockedDatesSet.add(current.format('YYYY-MM-DD'));
                    current.add(1, 'day');
                }
            }
        }

        // Handle edge case where reqFrom of one request equals reqTo of another
        requestsAccepted.forEach(ele => {
            requestsAccepted.forEach(ele2 => {
                if (moment(ele.reqFrom).isSame(ele2.reqTo, "day")) {
                    blockedDatesSet.add(moment(ele.reqFrom).format('YYYY-MM-DD'));
                }
            });
        });

        return blockedDatesSet;
    }, [data.requests]);

    const isDayBlocked = useCallback((day) => {
        return blockedDates.has(day.format('YYYY-MM-DD'));
    }, [blockedDates]);

    // Custom day rendering to show prices for available dates
    const renderDayContents = useCallback((day) => {
        const dayStr = day.format('YYYY-MM-DD');
        const isBlocked = blockedDates.has(dayStr);
        const price = availableTimesMapMemo.get(dayStr);
        const dayNumber = day.date();

        if (price && !isBlocked) {
            return (
                <div className="custom-day-with-price">
                    <div className="day-number">{dayNumber}</div>
                    <div className="day-price">{price}</div>
                </div>
            );
        }

        return <span>{dayNumber}</span>;
    }, [availableTimesMapMemo, blockedDates]);

    function getStandardTime() {
        const checkInStandardTime = moment(bookingPolicies?.checkInPolicy?.standardTime || '12:00', "HH:mm");
        const checkInHours = checkInStandardTime.hour();
        const checkInMinutes = checkInStandardTime.minute();
        const checkOutStandardTime = moment(bookingPolicies?.checkOutPolicy?.standardTime || '10:00', "HH:mm");
        const checkOutHours = checkOutStandardTime.hour();
        const checkOutMinutes = checkOutStandardTime.minute();
        return { checkInHours, checkInMinutes, checkOutHours, checkOutMinutes };
    }

    const calcBooking = useCallback(async (startDate, endDate) => {
        if (!startDate || !endDate || !data.unit) return;

        try {
            const result = await getAvailableTimeUnit(startDate, endDate);
            if (!result) return;

            const { transaction, allNights } = result;
            let totalCost = 0;

            if (data.unit.costInterval === "night") {
                totalCost = transaction.reduce((sum, ele) => sum + (ele.nights * ele.price), 0);
            } else if (data.unit.costInterval === "month") {
                totalCost = transaction.reduce((sum, ele) => sum + ((ele.nights / 30.5) * ele.price), 0);
            }
            const { checkInHours, checkInMinutes, checkOutHours, checkOutMinutes } = getStandardTime();
            setBookingData(prev => ({
                ...prev,
                reqNights: allNights,
                reqTotalCost: totalCost.toFixed(2),
                reqFrom: moment(startDate).utc(true).set({ hour: checkInHours, minute: checkInMinutes, second: 0, }).format(),
                reqTo: moment(endDate).utc(true).set({ hour: checkOutHours, minute: checkOutMinutes, second: 0, }).format()
            }));
        } catch (error) {
            console.error('Error calculating booking:', error);
            setError('حدث خطأ في حساب التكلفة');
        }
    }, [data.unit, getAvailableTimeUnit]);

    const smoothScroll = useCallback((e, id) => {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(id).offset().top - 85
        }, 100);
    }, []);

    const togglePopupContact = useCallback(() => {
        const container = $(".contacts-container");
        const popup = $(".contacts-popup");

        if (container.hasClass("animate__backInUp")) {
            container.removeClass("animate__backInUp").addClass("animate__backOutUp");
            popup.delay(500).fadeOut(0);
        } else {
            container.removeClass("animate__backOutUp").addClass("animate__backInUp");
            popup.fadeIn(0);
        }
    }, []);

    const redirectToInvoicePayment = useCallback(() => {
        const decoded = decodeToken();

        sessionStorage.setItem("bookingData", JSON.stringify(bookingData));
        sessionStorage.setItem("unitData", JSON.stringify(data.unit));
        sessionStorage.setItem("transaction", JSON.stringify(transaction));

        if (decoded) {
            navigate("/payment-invoice");
        } else {
            sessionStorage.setItem("isPaymentStop", "true");
            navigate("/login");
            toast.warning("رجاء تسجيل الدخول قبل الحجز", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                rtl: true
            });
        }
    }, [bookingData, data.unit, transaction, decodeToken, navigate]);

    const getUnitData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const id = params.id;
            const slug = getSlug();
            const unitData = await getData(`${slug}/${id}`);
            setData(unitData);
        } catch (error) {
            console.error('Error fetching unit data:', error);
            setError('حدث خطأ في تحميل البيانات');
        } finally {
            setLoading(false);
        }
    }, [params.id, getData, getSlug]);

    // Memoize PictureSlider rendering to avoid re-renders when unrelated state changes
    const memoPictureSlider = useMemo(() => <PictureSlider data={data} />, [data.unit?.media]);

    // Debounce booking calc to improve responsiveness
    const calcTimeoutRef = useRef(null);
    useEffect(() => {
        if (!isDateRangeValid) return;
        if (calcTimeoutRef.current) clearTimeout(calcTimeoutRef.current);
        calcTimeoutRef.current = setTimeout(() => {
            calcBooking(dateRange.startDate, dateRange.endDate);
        }, 300); // 300ms debounce
        return () => {
            if (calcTimeoutRef.current) {
                clearTimeout(calcTimeoutRef.current);
                calcTimeoutRef.current = null;
            }
        };
    }, [isDateRangeValid, calcBooking, dateRange.startDate, dateRange.endDate]);

    const renderMainContent = useCallback(() => {
        try {
            if (!data?.unit) return null;

            return (
                <>
                    {!mobileView ? (
                        <>
                            <section id='image-unit'>
                                {memoPictureSlider}
                            </section>

                            <section id='title-unit' className='mt-3'>
                                <div className='title-unit'>
                                    <h3 className='m-0 mt-2 fw-semibold'>{data.unit.unitName}</h3>
                                    <h6 className='code-title-unit'>({data.unit.unitCode})</h6>
                                    <ul className="info-unit d-flex justify-content-start">
                                        <li className='ms-md-5 ms-4'>
                                            <FontAwesomeIcon icon={faLocationDot} className='text-myPrimary ps-1' />
                                            <span className='text-myMediumGray'>{data.unit.country}</span>
                                        </li>
                                        <li className='ms-md-5 ms-4 text-myMediumGray'>
                                            <FontAwesomeIcon icon={faBed} className='text-myPrimary ps-1' />
                                            عدد الغرف <span>{data.unit.bedrooms}</span>
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <hr className='line-unit' />

                            <div className='row'>
                                <div className="col-md-8 mt-2">
                                    <section className='bar-unit' id='bar-unit'>
                                        <div className='d-flex justify-content-around mx-2 pb-4'>
                                            <h5 className='cursor-pointer' onClick={(e) => smoothScroll(e, "#desc-unit")}>المواصفات</h5>
                                            <h5 className='cursor-pointer' onClick={(e) => smoothScroll(e, "#location-unit")}>مكاني</h5>
                                            <h5 className='cursor-pointer' onClick={(e) => smoothScroll(e, "#bookingCalender-unit")}>المواعيد</h5>
                                            <h5 className='cursor-pointer' onClick={(e) => smoothScroll(e, "#policy-cancellation-unit")}>الشروط</h5>
                                        </div>
                                    </section>

                                    <section id='desc-unit' className='desc-unit'>
                                        <h4 className='fw-semibold'>الوصف</h4>
                                        <p>{data.unit.description}</p>
                                    </section>

                                    <hr className='line-unit' />

                                    <section id='services-unit' className='services-unit'>
                                        <h4 className='fw-semibold'>الخدمات</h4>
                                        <div className='row g-1'>
                                            <ul className='col-sm-6 m-0'>
                                                {displayedServices.firstColumn}
                                            </ul>
                                            <ul className='col-sm-6 m-0'>
                                                {displayedServices.secondColumn}
                                            </ul>
                                        </div>
                                        {servicesHtml.length > 8 && (
                                            <div>
                                                <button
                                                    className='button-services'
                                                    onClick={() => setShowMoreServices(!showMoreServices)}
                                                >
                                                    {showMoreServices ? "اضغط هنا لأقل" : "اضغط هنا للمزيد"}
                                                </button>
                                            </div>
                                        )}
                                    </section>
                                </div>

                                <div className='col-md-4 d-none d-md-inline-block mt-5'>
                                    <section id='booking-unit' className='booking-unit mb-5'>
                                        <h5 className='text-myPrimary fw-semibold mb-4'>
                                            <span>{data.unit.cost} </span>ج.م /
                                            <span>{data.unit.costInterval === "night" ? "ليلة" : "شهر"}</span>
                                        </h5>

                                        <div className='calender-booking'>
                                            {/* {memoizedDateRangePicker} */}
                                            <DateRangePicker
                                                isRTL={true}
                                                startDate={dateRange?.startDate}
                                                endDate={dateRange?.endDate}
                                                startDateId='startDate'
                                                endDateId='endDate'
                                                onDatesChange={handleChangeDate}
                                                focusedInput={focusedInput2}
                                                onFocusChange={setFocusedInput2}
                                                startDatePlaceholderText='من'
                                                endDatePlaceholderText='الي'
                                                displayFormat="YYYY/MM/DD"
                                                customArrowIcon={"-"}
                                                isOutsideRange={isOutsideRange}
                                                isDayBlocked={isDayBlocked}
                                                renderDayContents={renderDayContents}
                                                numberOfMonths={2}
                                                hideKeyboardShortcutsPanel
                                                reopenPickerOnClearDates
                                                keepOpenOnDateSelect={false}
                                                minimumNights={0}
                                                maxDate={moment().add(1, 'year')}
                                                minDate={moment().startOf('month')}
                                            />
                                        </div>

                                        <div className='individuals-booking d-flex justify-content-between align-items-center'>
                                            <div className='py-2'>
                                                <h6 className='m-0'>الأفراد</h6>
                                            </div>
                                            <div className='d-flex'>
                                                <button className='btn-icon-guests' onClick={handleChangeMinusGuests}>
                                                    <FontAwesomeIcon className='icon-booking' icon={faMinus} />
                                                </button>
                                                <div className='mx-3 my-auto mx-2'>
                                                    {bookingData.reqGuests}
                                                </div>
                                                <button className='btn-icon-guests' onClick={handleChangePlusGuests}>
                                                    <FontAwesomeIcon className='icon-booking' icon={faPlus} />
                                                </button>
                                            </div>
                                        </div>

                                        <div>
                                            <button
                                                className='booking-button'
                                                onClick={redirectToInvoicePayment}
                                                disabled={!bookingData.reqNights || availableTime === false}
                                            >
                                                إحجز
                                            </button>
                                            {availableTime === false && (
                                                <div className='myText-warning'>غير متاح هذا التاريخ</div>
                                            )}
                                        </div>

                                        {renderTransactionDetails}

                                        <hr className='line-booking' />
                                        <div className='d-flex justify-content-between mx-3 align-items-center my-3'>
                                            <p>الإجمالي</p>
                                            <p>{bookingData.reqTotalCost}</p>
                                        </div>
                                        <div className='mx-3'>
                                            <p className='myFs-10'>
                                                <span>*</span>اي مناقشة في السعر تتم من خلال مكالمة تأكيد الحجز بعد اتمام عملية الحجز<span>*</span>
                                            </p>
                                            <p className='myFs-10'>
                                                <span>*</span>سيتم الإتفاق على مبلغ جديه الحجز و كذلك التأمين خلال الإتصال لتأكيد الحجز<span>*</span>
                                            </p>
                                        </div>
                                    </section>
                                </div>
                            </div>

                            {/* ...existing sections for calendar, location, policy... */}
                            <hr className='line-unit' />
                            <section id='bookingCalender-unit' className='bookingCalender-unit'>
                                <h4 className='fw-semibold'><span>{bookingData.reqNights}</span> ليالي</h4>
                                {dateRange.startDate && dateRange.endDate ? <p className='mb-4 d-block'><span>{moment(dateRange.startDate).format("LL")}</span> - <span className='w-fitContent w-100'>{moment(dateRange.endDate).format() !== "Invalid date" ? moment(dateRange.endDate).format("LL") : <>الي</>}</span></p> : <p className='mb-4 d-block'><span>من</span> - <span className='w-fitContent w-100'>الي</span></p>}
                                <div className='ms-1 d-none d-md-inline-block' >
                                    {/* {memoizedDesktopCalendar} */}
                                    <DayPickerRangeController
                                        isRTL={true}
                                        startDate={dateRange.startDate}
                                        endDate={dateRange.endDate}
                                        onDatesChange={(e) => handleChangeDate(e)}
                                        onFocusChange={handleFocusChange}
                                        focusedInput={focusedInput}
                                        isOutsideRange={isOutsideRange}
                                        isDayBlocked={isDayBlocked}
                                        numberOfMonths={2}
                                        daySize={45}
                                        noBorder
                                        hideKeyboardShortcutsPanel
                                        keepOpenOnDateSelect={false}
                                        minimumNights={0}
                                        maxDate={moment().add(1, 'year')}
                                        minDate={moment().startOf('month')}
                                        renderDayContents={renderDayContents}

                                    />
                                </div>
                                <div className='ms-1 d-inline-block d-md-none' >
                                    {/* {memoizedMobileCalendar} */}
                                    <DayPickerRangeController
                                        isRTL={true}
                                        startDate={dateRange.startDate}
                                        endDate={dateRange.endDate}
                                        onDatesChange={(e) => handleChangeDate(e)}
                                        onFocusChange={handleFocusChange}
                                        focusedInput={focusedInput}
                                        isOutsideRange={isOutsideRange}
                                        isDayBlocked={isDayBlocked}
                                        numberOfMonths={1}
                                        daySize={40}
                                        noBorder
                                        hideKeyboardShortcutsPanel
                                        keepOpenOnDateSelect={false}
                                        minimumNights={0}
                                        maxDate={moment().add(1, 'year')}
                                        minDate={moment().startOf('month')}
                                        renderDayContents={renderDayContents}
                                    />
                                </div>
                            </section>
                            <hr className='line-unit' />
                            <section id='location-unit' className='location-unit'>
                                <h4 className='fw-semibold'>المكان !</h4>
                                <h5 className='mb-4'>{data.unit.country}</h5>
                                <LocationMap address={data.unit.location} />
                            </section>
                            <hr className='line-unit' />
                            <section id='policy-cancellation-unit' className='policy-cancellation-unit'>
                                <h4 className='mb-3'>الشروط و سياسة الإلغاء</h4>
                                <div className='d-md-flex justify-content-start'>
                                    <div className='ms-5 policy-item-1 mb-2'>
                                        {/* <h5>الشروط</h5> */}
                                        <ul>
                                            {/* {data.unit.isCheckin || data.unit.isCheckout ? <></> : <h6 className='fw-semibold pt-2 mb-1'>لا يوجد</h6>} */}
                                            <li>تسجيل الوصول من {moment(bookingPolicies?.checkInPolicy?.standardTime, 'HH:mm').format('hh:mm a')}</li>
                                            <li>تسجيل المغادرة من {moment(bookingPolicies?.checkOutPolicy?.standardTime, 'HH:mm').format('hh:mm a')}</li>
                                        </ul>
                                    </div>
                                    {/* <hr className='line-unit d-md-none d-inline-block' /> */}
                                    {/* <div className=''>
                                        <h5>سياسة الإلغاء</h5>
                                        <ul className='policy-item-2 '>
                                            <li className='mb-1'>
                                                <p>هذا الحجز غير قابل للاسترداد. </p>
                                                {data.unit.cancelation ? <p>قابل للأسترداد بحد اقصي يومين من الحجز</p> : <p>هذا الحجز غير قابل للاسترداد. </p>}
                                            </li>
                                        </ul>
                                    </div> */}
                                </div>
                                {/* <hr className='line-unit d-inline-block' /> */}
                                <div className='mt-2 ms-5'>
                                    <ul className='policy-item-2 '>
                                        <li className='mb-1'>
                                            • ممنوع إصطحاب الحيوانات الاليفة
                                        </li>
                                        <li className='mb-1'>
                                            • ممنوع إدخال المشروبات الكحولية بكل انواعها حرصاً على عدم الإحراج
                                        </li>
                                        <li className='mb-1'>
                                            • الالتزام بالعدد المتاح للوحدة
                                        </li>
                                        <li className='mb-1'>
                                            • فى حال الغاء الحجز فى فترة زمنية اقل من 21 يوم من تاريخ الاقامة, لا يتم استرجاع اياً من المدفوعات السابقة و لا يسمح بنقل المدفوعات لحجز اخر
                                        </li>
                                        <li className='mb-1'>
                                            • عدم امكانيه تسكين افراد بدون اضافة صور الرقم القومي
                                        </li>
                                        <li className='mb-1'>
                                            • بالنسبة للمتزوجين احضار قسيمة الزواج في حاله عدم وجود اسم الزوج في بطاقة الزوجة
                                        </li>
                                    </ul>
                                </div>
                            </section>
                            <section id='footer-booking-unit-mobile'>
                                <div className="d-md-none d-flex justify-content-between align-items-center px-3 footer-booking-unit-mobile">
                                    <div className=''>
                                        <h5 className='text-myPrimary fw-semibold'><span>{data.unit.cost}</span> ج.م / ليلة</h5>
                                    </div>
                                    <div className='d-flex align-items-center '>
                                        <div>
                                            <button className='booking-button-mobile' onClick={() => setMobileView(true)}>إحجز</button>
                                        </div>
                                    </div>

                                </div>
                            </section>
                        </>
                    ) : (
                        <MobileBooking
                            bookingData={bookingData}
                            data={data}
                            dateRange={dateRange}
                            handleChangeDate={handleChangeDate}
                            handleChangePlusGuests={handleChangePlusGuests}
                            handleChangeMinusGuests={handleChangeMinusGuests}
                            handleFocusChange={handleFocusChange}
                            isOutsideRange={isOutsideRange}
                            isDayBlocked={isDayBlocked}
                            focusedInput2={focusedInput2}
                            setFocusedInput2={setFocusedInput2}
                            setMobileView={setMobileView}
                            setOldClientName={setOldClientName}
                            oldClientName={oldClientName}
                            transaction={transaction}
                            renderDayContents={renderDayContents}
                        />
                    )}
                </>
            );
        } catch (renderError) {
            console.error('Render error:', renderError);
            return (
                <div className="alert alert-danger" role="alert">
                    حدث خطأ في عرض المحتوى
                </div>
            );
        }
    }, [data, mobileView, displayedServices, servicesHtml, showMoreServices, dateRange, bookingData, smoothScroll, handleChangeDate, setFocusedInput2, focusedInput2, isOutsideRange, isDayBlocked, handleChangeMinusGuests, handleChangePlusGuests, redirectToInvoicePayment, availableTime, renderTransactionDetails, focusedInput, handleFocusChange, transaction, setMobileView, setOldClientName, oldClientName]);

    // Effects - Move all useEffect hooks here
    useEffect(() => {
        getUnitData();
    }, [getUnitData]);

    useEffect(() => {
        loadBookingPolicies();

        return () => {
            setBookingPolicies({});
        }
    }, []);


    // Early returns AFTER all hooks
    if (loading) {
        return (
            <div className='container'>
                <section>
                    <div className='image-unit d-none d-md-flex'>
                        <ContentLoader
                            rtl
                            speed={2}
                            width={"100%"}
                            height={"432px"}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            radius={40}
                        >
                            <rect x="0" y="0" rx="5" ry="5" width="50%" height="100%" />
                            <rect x="51%" y="0" rx="5" ry="5" width="24%" height="49%" />
                            <rect x="51%" y="51%" rx="5" ry="5" width="24%" height="49%" />
                            <rect x="76%" y="0" rx="5" ry="5" width="24%" height="49%" />
                            <rect x="76%" y="51%" rx="5" ry="5" width="24%" height="49%" />
                        </ContentLoader>
                    </div>
                    <div className="d-flex d-md-none text-center">
                        <ContentLoader
                            rtl
                            speed={2}
                            width={"100%"}
                            height={"432px"}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                        >
                            <rect x="0" y="0" rx="5" ry="5" width="100%" height="100%" />
                        </ContentLoader>
                    </div>
                </section>
                <section>
                    <div className='title-unit'>
                        <ContentLoader
                            rtl
                            speed={2}
                            width={"100%"}
                            height={"600px"}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                        >
                            <rect x="0" y="20" rx="5" ry="5" width="100%" height="40px" />
                            <rect x="0" y="80" rx="5" ry="5" width="40%" height="30px" />
                            <rect x="0" y="130" rx="5" ry="5" width="60%" height="80px" />
                            <rect x="0" y="230" rx="5" ry="5" width="60%" height="80px" />
                        </ContentLoader>
                    </div>
                </section>
            </div>
        );
    }

    if (error) {
        return (
            <div className='container'>
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            </div>
        );
    }

    // Main return structure
    return (
        <>
            <style>{`
                .custom-day-with-price {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                    padding: 2px;
                }
                .custom-day-with-price .day-number {
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.2;
                }
                .custom-day-with-price .day-price {
                    font-size: 10px;
                    color: #9a9a9a;
                    font-weight: 600;
                    line-height: 1;
                    margin-top: 2px;
                    white-space: nowrap;
                }
                .CalendarDay__default:hover .custom-day-with-price .day-price {
                    color: #fff;
                }
                .CalendarDay__selected .custom-day-with-price .day-price {
                    color: #fff;
                }
            `}</style>
            <ConfirmPayment getUnitData={getUnitData} />
            <div className='container'>
                {data?.unit ? (
                    renderMainContent()
                ) : (
                    <div>
                        <section>
                            <div className='image-unit d-none d-md-flex'>
                                <ContentLoader
                                    rtl
                                    speed={2}
                                    width={"100%"}
                                    height={"432px"}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    radius={40}
                                >
                                    <rect x="0" y="0" rx="5" ry="5" width="50%" height="100%" />
                                    <rect x="51%" y="0" rx="5" ry="5" width="24%" height="49%" />
                                    <rect x="51%" y="51%" rx="5" ry="5" width="24%" height="49%" />
                                    <rect x="76%" y="0" rx="5" ry="5" width="24%" height="49%" />
                                    <rect x="76%" y="51%" rx="5" ry="5" width="24%" height="49%" />
                                </ContentLoader>
                            </div>

                            <div className="d-flex d-md-none text-center">
                                <ContentLoader
                                    rtl
                                    speed={2}
                                    width={"100%"}
                                    height={"432px"}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                >
                                    <rect x="0" y="0" rx="5" ry="5" width="100%" height="100%" />
                                </ContentLoader>
                            </div>
                        </section>

                        <section>
                            <div className='title-unit'>
                                <ContentLoader
                                    rtl
                                    speed={2}
                                    width={"100%"}
                                    height={"600px"}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                >
                                    <rect x="0" y="20" rx="5" ry="5" width="100%" height="40px" />
                                    <rect x="0" y="80" rx="5" ry="5" width="40%" height="30px" />
                                    <rect x="0" y="130" rx="5" ry="5" width="60%" height="80px" />
                                    <rect x="0" y="230" rx="5" ry="5" width="60%" height="80px" />
                                </ContentLoader>
                            </div>
                        </section>
                    </div>
                )}
            </div>

            <div className='secure-mobile-view'>
                <div className='contacts-popup'>
                    <ContactsPopup
                        bookingData={bookingData}
                        togglePopupContact={togglePopupContact}
                        setOldClientName={setOldClientName}
                        oldClientName={oldClientName}
                    />
                </div>
            </div>

            {!mobileView && (
                <div className='parent-preview-unit-footer'>
                    <div className='container preview-unit-footer mb-md-0'>
                        <Footer />
                    </div>
                </div>
            )}
        </>
    );
}